// extracted by mini-css-extract-plugin
module.exports = {"edit":"EditableLabel_edit__1dDp0","readonly":"EditableLabel_readonly__bUOcs"};